import React from 'react';
const TimeIndicators = ({ date = new Date() }) => {
    const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(date);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "p-3 flex items-center relative" },
            React.createElement("button", { className: "absolute left-0 text-gray-500" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                    React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 19l-7-7 7-7" }))),
            React.createElement("div", { className: "flex-1 flex justify-between text-xs text-gray-500 px-2" },
                React.createElement("span", null, "08:00"),
                React.createElement("span", null, "09:00"),
                React.createElement("span", null, "10:00"),
                React.createElement("span", null, "11:00"),
                React.createElement("span", null, "12:00"),
                React.createElement("span", null, "13:00"),
                React.createElement("span", null, "14:00"),
                React.createElement("span", null, "15:00")),
            React.createElement("button", { className: "absolute right-0 text-gray-500" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                    React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5l7 7-7 7" })))),
        React.createElement("div", { className: "p-3 text-xs/[0.5] text-gray-500 text-center border-t" },
            React.createElement("span", null, formattedDate))));
};
export default TimeIndicators;
